module.exports = __webpack_public_path__ + "img/shop-light.d938e1b3.svg";